var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-scene-thumb",style:({ aspectRatio: `${_vm.overlay.width} / ${_vm.overlay.height}` })},[(_vm.scene.thumbnail)?_c('img',{attrs:{"src":_vm.scene.thumbnail,"draggable":"false"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }